module.exports = __webpack_public_path__ + "static/media/p8-3.b41639d6.png";